<nz-row nzJustify="space-between" nzAlign="middle">
    <nz-col style="margin-bottom: 10px;">
        <input nz-input placeholder="Search..." [(ngModel)]="searchValue" (ngModelChange)="onSearch()" />
    </nz-col>
    <nz-col>
        <button nz-button nzType="primary" (click)="onAdd()">Add</button>
    </nz-col>
</nz-row>

<nz-spin [nzSpinning]="loading" [nzTip]="'Loading data...'">
    <nz-table [nzData]="outsourcingRequestVendorList" [nzBordered]="true" [nzSize]="'middle'" style="white-space: pre;overflow: auto;"
        [nzShowPagination]="false">
        <thead>
            <tr>
                <th>Vendor</th>
                <th>Vendor Response Status</th>
                <th>Type</th>
                <!-- <th>Access Token</th> -->
                <th>Finalized</th>
                <!-- <th>Quotation Request</th> -->
                <th>Shortlisted</th>
                <th>Submitted At</th>
                <th>Created At</th>
                <th>Created By</th>
                <th>Get Link</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of outsourcingRequestVendorList">
                <td (click)="onVendorDetails(item?.vendor)" style="font-weight: 500;"> <a href="javascript:void(0)"> {{ item.vendor_details.name | titlecase }} </a> </td>
                <td> <nz-tag [nzColor]="getStatusBadge(item?.vendor_response_status)">  {{ item?.vendor_response_status }} </nz-tag> </td>
                <!-- <td>{{ item?.access_token }}</td> -->
                <td><img nz-image height="30px" [nzSrc]="getOursouringTypeImage(item)" alt="brand-image-{{item.id}}"
                [nzFallback]="sampleFallbackImage" /> <span style="margin-left: 5px;">  {{ item?.quotation_request_details?.outsourcing_event_request_details?.outsourcing_type_details?.name }} </span> </td>
                <td>
                    <nz-tag [nzColor]="item.is_finalized ? 'blue' : 'default'">
                        {{ item?.is_finalized ? 'Yes' : 'No' }}
                    </nz-tag>
                </td>
                <!-- <td>{{ item?.quotation_request }}</td> -->
                <td>
                    <nz-tag [nzColor]="item.is_shortlisted ? 'green' : 'default'">
                        {{ item?.is_shortlisted ? 'Yes' : 'No' }}
                    </nz-tag>
                </td>
                <!-- <td>{{ item?.submitted_at | date: 'yyyy-MM-dd HH:mm' }}</td>
                 <td>{{ item?.created_at | date: 'yyyy-MM-dd HH:mm' }}</td> -->
                  <td>{{ item?.submitted_at | date: 'MMM d, y, h:mm a' }}</td>
                 <td>{{ item?.created_at | date: 'MMM d, y, h:mm a' }}</td>
                <td><nz-tag [nzColor]="'cyan'" class="user-badge" [nzBordered]="false">
                            <nz-avatar nzSize="small" *ngIf="item?.created_by_name"
                                [nzText]="item?.created_by_name[0].toUpperCase()" style="margin-right: 4px;"></nz-avatar>
                            {{ item?.created_by_name ? item?.created_by_name : '&nbsp;-' }}
                            </nz-tag>
                    </td>

                <td>
                    <button nz-button nzType="link" (click)="copyLink(item)"> <nz-icon nzType="copy" nzTheme="outline" /> Copy Link</button>
                </td>
                 <td>
                    <button nz-button nzType="default" nzSize="small" (click)="onEdit(item)" ><nz-icon nzType="edit"
                            nzTheme="outline" />
                    </button>
                    <button nz-button nzType="default" nzDanger style="margin-left: 10px;" nzSize="small"
                     nz-popconfirm   nzPopconfirmTitle="Are you sure delete this request?"
                    nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteRequest(item?.quotation_request_vendor_id)"

                      class="custom-popconfirm"

            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"

                    ><nz-icon nzType="delete" nzTheme="outline" />
                    </button>
                </td>
            </tr>
        </tbody>
    </nz-table>
</nz-spin>


<ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
